/**
 * @file event-error.service.js
 * @module EventErrorService
 * @description Reads the message the events API returns on a failed request.
 */

/**
 * Message of a failed events request: the validation messages of a 400, the
 * backend message of other errors (e.g. 409 duplicated code), or the fallback.
 * @param {Object} error - Axios error.
 * @param {string} fallback
 * @returns {string}
 */
export const getEventErrorMessage = (error, fallback) => {
  const data = (error && error.response && error.response.data) || {};
  if (Array.isArray(data.error) && data.error.length) {
    return data.error.map(detail => detail.message).join(". ");
  }
  if (data.message && data.message !== "bad request") return data.message;
  return fallback;
};
